module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAACXBIWXMAAAsSAAALEgHS3X78AAABLklEQVQ4Ea2TsUrEQBCGvwRBFOEEW4WrbJMXEO8BLO4R0pn6nsAHEOuU9wgp7L28waW1OrC2OBDEauXPZsxeEjzE+2Eguzvf7MxkNnLOsaM8ygDZ7e4BFbCkcMtwswuQR1OgBBJ+Vw3MKdymC+DhNTDZA5u2QKogcbtRNvDpOVzP4GI6RK5SuHvw5/4iMRy1Nfu0L1NYvMDnFp5m8Lbu4MUKTibwDLyuaJg8yuK2YV7vGw/LUYDAENZZXYZ5ZZG7xw1SNeDrw+8dnw2zahXTlxzkKFigTN8jMKMB/qhhACvBbrZMrCcjGVQ/K/2+sGGPN976je1Uxc14hgEMtpqtJxYkmYcBljaJ6k7SDJJmQb9T1i9NsGbAz0FN4dIDjbJ/GCpOD2Wf5NPAWvzvOQPfG0+HwjzkfRcAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/page/register/delete.png
// module id = B6fT
// module chunks = 1